import React, { useContext, useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../components/helper-components/loading-spinner";
import { strExeGetAction } from "../../redux/actions/store-action";
import { DataContext } from "../../components/layouts/main-layout";
import StoreExeViewEdit from "../../components/store-execution/edit-view-store-exe";
import AccessDenied from "../../components/helper-components/access-denied";
const ViewStoreExecution = () => {
  const { permissionFn } = useContext(DataContext);
  // Same access check as Price List: the page needs "read" on
  // store_execution and shows AccessDenied without it.
  const hasAccess = permissionFn("store_execution")?.read === true;
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [exeData, setExeData] = useState({});
  const [reload, setReload] = useState(false);

  useEffect(() => {
    if (!hasAccess) return;
    dispatch(strExeGetAction(id, onSuccess, onError));
  }, [reload, hasAccess]);
  const onSuccess = (data) => {
    console.log(data, "gdfgdgdgdfgfdg");
    setLoading(false);
    setExeData(data?.data?.[0]);
  };
  const onError = (data) => {
    loading(false);
  };
  if (!hasAccess) {
    return (
      <InnerLayout title="View Store-Execution" backBtn={true}>
        <AccessDenied message="You don't have permission to view Store Execution." />
      </InnerLayout>
    );
  }

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout
          title={"View Store-Execution"}
          title1={id}
          view={true}
          onclkEditFn={() => navigate(`/edit-store/${id}`)}
        >
          <StoreExeViewEdit
            id={id}
            setReload={setReload}
            reload={reload}
            permissionFn={permissionFn}
            exeData={exeData}
          />
        </InnerLayout>
      )}
    </>
  );
};

export default ViewStoreExecution;
